export const MIN_DEPOSIT_AMOUNT = 50 as const;
